// @ vendor
const Immutable = require('immutable');

// @ constants
const actionTypes = require('../../../constants/actionTypes');

function setInitialState() {
    return Immutable.fromJS({
        valid: false,
        isDisclaimerChecked: false,
        hasSignaturePattern: true,
        errorFlags: {
            disclaimer: false,
        },
    });
}

function validateStep(step) {
    const isDisclaimerChecked = step.get('isDisclaimerChecked');
    return step.merge({
        valid: isDisclaimerChecked,
        errorFlags: {
            disclaimer: !isDisclaimerChecked,
        },
        loading: false,
    });
}

function cmWalletBuyStep2Legacy(state = setInitialState(), action) {
    switch (action.type) {
        case actionTypes.CM_VALIDATE_STEP:
            return validateStep(state);
        case actionTypes.CM_LEGAL_DISCLAIMER_CHANGED:
            return state.merge({
                isDisclaimerChecked: action.payload.value,
                errorFlags: {
                    disclaimer: false,
                },
            });
        case actionTypes.CM_VALIDATE_REQUEST:
            return state.merge({
                loading: true,
            });
        case actionTypes.CM_VALIDATE_SUCCESS:
        case actionTypes.CM_VALIDATE_FAILURE:
            return state.merge({
                loading: false,
            });
        default:
            return state;
    }
}

module.exports = cmWalletBuyStep2Legacy;
